export default __webpack_public_path__ + "static/sunseap-logo-61ea01470f1755c6f6b44b1e19440134.png";